import { Box } from "@mui/material";
import React from "react";


export default function AllergenIcon({source}: {source: string}) {
    return <Box component={"img"} src={source} style={{ width: "24px", height: "24px", borderRadius: "50%"}}></Box>
}

